import styles from "./styles.module.scss";

const CustomPlaceholder = ({ onClick, condition, defaultText, text, icon }) => {
  // Handle the logic outside of JSX
  const displayText = condition ? text : defaultText;

  return (
    <div
      className={`${styles.placeHolder} ${!condition ? styles.lightText : ""}`}
      onClick={onClick}
    >
      {/* Render icon if provided */}
      {icon && <img src={icon} alt="icon" className={styles.icon} />}
      {displayText}
    </div>
  );
};

export default CustomPlaceholder;
